import { globals, utilities } from "../../styles";
import { close_Icon } from "../../assets/icons";
import styles from "./FullscreenModal.module.css";

function FullscreenModal(props: {
  children: React.ReactNode;
  onClose?: () => void;
  style?: { background?: React.CSSProperties; container?: React.CSSProperties };
  className?: { background?: string; container?: string };
}) {
  const { children, onClose, style, className } = props;
  return (
    <div
      className={`${styles["fullscreen-modal"]} ${utilities["flex-center"]} ${
        className?.background ?? ""
      }`}
      style={style?.background ?? {}}
    >
      <div
        className={`${styles["container"]} ${className?.container ?? ""}`}
        style={{ position: "relative", ...(onClose ? { paddingTop: "70px" } : {}), ...style?.container }}
      >
        {onClose && (
          <button
            className={`${globals["button-wrapper"]} ${globals["back-btn--top-left"]}`}
            onClick={onClose}
          >
            <div className={globals["back-btn"]}>
              <img src={close_Icon} alt="Close" />
            </div>
          </button>
        )}
        {children}
      </div>
    </div>
  );
}

export default FullscreenModal;
